export const TierLevels = {
    TIER1: 'Tier1',
    TIER2: 'Tier2',
    TIER3: 'Tier3',
    TIER4: 'Tier4'
};

export const TierStandardLimitMap = new Map<string | number, number>([
    [TierLevels.TIER1, 2500],
    [TierLevels.TIER2, 5000],
    [TierLevels.TIER3, 7500],
    [TierLevels.TIER4, 10000],
]);

export const TierLevelOptions = [
    {
        value: TierLevels.TIER1,
        label: 'Tier 1 up to $2,500',
        description: 'Immediate needs met, stable, some remaining unmet needs; monthly monitoring to update status or may be closed due to lack of resource for identified need (may be reopened if resource(s) becomes available during period of performance).'
    },
    {
        value: TierLevels.TIER2,
        label: 'Tier 2 up to $5,000',
        description: 'Some remaining unmet needs or in current rebuild/repair status; monthly contact to monitor progress.'
    },
    {
        value: TierLevels.TIER3,
        label: 'Tier 3 up to $7,500',
        description: 'Significant unmet needs, Disaster Recovery Plan being developed and monitored; bi-weekly or weekly contact.'
    },
    {
        value: TierLevels.TIER4,
        label: 'Tier 4 up to $10,000',
        description: 'Immediate and long-term unmet needs, may lack capacity, or be highly dependent on social services due to low literacy, elderly, low income, or disabled, weekly contact.'
    }
];
